<div id="modalrooms" style="position: relative;">
  <div id="modalRooms">
    <div class="modal-content" style="padding-bottom: 50px;padding: 3em 4.5em;position: relative">
      <div class="d-flex justify-content-between mx-auto" style="width: 98%">
        <p class="title mb-0 mt-2 pr-5" style="font-family: 'Rubik', sans-ferif;font-size: 30px;font-weight: 500;line-height: 1 !important; color: #3f3f3f !important;">
          {{ hotel.title }}
        </p>
        <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
          <span aria-hidden="true" style="font-size: 50px; font-weight: 100;">&times;</span>
        </button>
    </div>
      <div class="d-flex align-items-start" style="margin-left: .8em;margin-bottom:.85em">
        <ng-container *ngFor="let star of starArray">
          <img
            *ngIf="star <= rate"
            class="mr-1"
            width="13"
            height="13"
            src="../../../../../../assets/icons/itinerary/estrella-01.svg"
            alt="estrella"
          />
          <img
            class="mr-1"
            *ngIf="star > rate"
            width="13"
            height="13"
            style="filter: grayscale(1); opacity: 0.5"
            src="../../../../../../../assets/icons/itinerary/estrella-01.svg"
            alt="estrella"
          />
        </ng-container>
    </div>
    <div class="d-flex align-items-start justify-content-start" style="gap: .5em;margin-bottom: 6px">

        <div class="d-flex justify-content-start" >
          <div class="d-flex mr-1">
            <i class="i-placeholder" style="margin-left: 4px"></i>
          </div>
          <div *ngIf="hotel?.additionalInfo?.location" class="d-flex justify-content-between align-items-center " style="width: 100%;">
            <div class="d-flex flex-column justify-content-center" >
              <p *ngIf="getAddress(hotel?.additionalInfo?.location, true)" class=" mb-0 line-height" style="font-family: 'Rubik', sans-serif;font-size: 14px;font-weight: 600;color: #3f3f3f !important; line-height: 1.2">{{stingUpperCase(getAddress(hotel?.additionalInfo?.location, true))}}</p>
              <p *ngIf="getAddress(hotel?.additionalInfo?.location, false)" class=" mb-0 line-height" style="font-family: 'Rubik', sans-serif;font-size: 14px;font-weight: 600;color: #3f3f3f !important; line-height: 1.2">{{stingUpperCase(getAddress(hotel?.additionalInfo?.location, false))}}</p>
              <p class=" mb-0 line-height" style="font-family: 'Rubik', sans-serif;font-size: 14px;font-weight: 600;color: #3f3f3f !important">{{stingUpperCase(payload?.city)}}</p>
            </div>



          </div>
        </div>

    </div>

    <div class="d-flex mt-3 mb-4 mx-3 " style="border-bottom: 2px solid #939292; border-top: 2px solid #939292;height: 55px">
      <div class="d-flex align-items-center justify-content-center px-3" style="width: 50%;border-right: 2px solid #939292;">
        <span
              style="font-family: 'Rubik', sans-serif;font-size: 14px; font-weight: 600;">
              <span style="font-weight: 400;">In:</span> {{arrivalDate | date:'dd - MMM - YY'}}&nbsp;&nbsp;&nbsp;<span style="font-weight: 400;">|&nbsp;&nbsp;&nbsp;Out:</span> {{departureDate | date:'dd - MMM - YY'}}</span>
      </div>
      <div class="d-flex align-items-center justify-content-around" style="width: 100%">

                <!-- <div *ngIf="activeBed" class="mr-2 d-flex align-items-center"> -->
                  <div class="d-flex align-items-center py-2">
                    <img #icon src="../../../../assets/icons/search-result/hotel/filtro/CAMA.svg" class="ml-2" style="width: 22px;margin-bottom: 2px;" alt="">
                    <!-- <i class="i-bed-room mr-1" aria-hidden="true"></i> -->
                    <p class="mb-0 ml-1 " style="font-family: 'Rubik', sans-serif;font-size: 14px; font-weight: 400;">{{payload.others?.hotels?.roomConfiguration?.length }} Habitación</p>
                  </div>
                  <div  class="d-flex align-items-center ml-2 py-2">
                    <img #icons_two src="../../../../assets/icons/search-result/persona.svg" class="ml-2"  style="width: 24px;" alt="">
                    <!-- <i class="i-adults mr-1 ml-3" aria-hidden="true"></i> -->
                    <p class="mb-0 ml-1 " style="font-family: 'Rubik', sans-serif;font-size: 14px; font-weight: 400;">{{getConfigurationRooms( payload.others?.hotels?.roomConfiguration, 'adults')}} Adultos</p>
                  </div>
                  <div class="d-flex align-items-center ml-2 py-2">
                    <img #icons_two src="../../../assets/icons/search-result/hotel/infante.svg" class="ml-2" style="width: 20px;" alt="">
                    <!-- <i  class="i-child mr-1 ml-3" aria-hidden="true"></i> -->
                    <p class="mb-0 ml-1 " style="font-family: 'Rubik', sans-serif;font-size: 14px; font-weight: 400;">{{getConfigurationRooms( payload.others?.hotels?.roomConfiguration, 'childs') }} Niños</p>
                  </div>

      </div>
    </div>



  <div *ngIf="action && action !== 'comments'"
       class="d-flex mt-3 justify-content-between mx-3"
       style="margin-bottom: 2.6em;gap:2px">
    <button
            *ngIf="quote"
            class="btn-tabs w-100 py-4 d-flex align-items-center justify-content-center"
            [ngStyle]="{
              'color': tab === 'rooms' ? buttonColorActiveDark : buttonTextActive
            }"
             style="background-color: #f0f0f0;"
            (click)="tab='rooms'"
            >HABITACIÓN</button>
    <button
            class="btn-tabs w-100 py-4 d-flex align-items-center justify-content-center"
            [ngStyle]="{
              'color': tab === 'info' ? buttonColorActiveDark : buttonTextActive
            }"
             style="background-color: #f0f0f0;"
            (click)="tab='info'"
            >INFO</button>
    <button
            class="btn-tabs w-100 py-4 d-flex align-items-center justify-content-center"
            [ngStyle]="{
              'color': tab === 'maps' ? buttonColorActiveDark : buttonTextActive
            }"
             style="background-color: #f0f0f0;"
            (click)="tab='maps'; mapMarker()"
            >MAPA</button>
    <button
            class="btn-tabs w-100 py-4 d-flex align-items-center justify-content-center"
            [ngStyle]="{
              'color': tab === 'photos' ? buttonColorActiveDark : buttonTextActive
            }"
             style="background-color: #f0f0f0;"
            (click)="tab='photos'; "
            >FOTOS</button>
    <button
            class="btn-tabs w-100 py-4 d-flex align-items-center justify-content-center"
            style="background-color: #f0f0f0;"
            [ngStyle]="{
              'color': tab === 'comments' ? buttonColorActiveDark : buttonTextActive
            }"
            (click)="tab='comments'; "
            >COMENTARIOS</button>
  </div>

  <div *ngIf="action && action !== 'comments' && tab == 'rooms'">
    <p class="mb-0 rubik-semibold-13pt ml-3 pl-4" style="font-size: 22px;padding-bottom: .6em;font-weight: 500;color: black">Seleccione las opciones de alojamiento</p>
    <div class="d-flex align-items-center mb-3 pb-2 mr-3" style="margin-left: 1.15em;">


      <div class="py-2 pl-5" style="width: 42%;padding-right: 3.7em;">
        <label style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;line-height: 1;margin-bottom: .55em; margin-left: 5px;">Régimen</label>
        <div class="d-flex align-items-center justify-content-between" style="gap: 1.2em">
            <div *ngFor="let r of mealsFiltersArr; let i = index"
                class="option-card"
                [class.selected]="selectedOptionIndex[i]"
                (click)="filterTypeBoardName(i, r.key)"
                >
                <div
                      class="d-flex justify-content-center align-items-center"
                      style="padding:.25em;border-radius: 4px"
                      [tooltip]="r.name"
                      [ngStyle]="{'background-color': r.status !== 'no_available' &&
                                            selectedOptionIndex[i] ?
                                            clientSetting?.clients_setting_global?.color_main_1 :
                                            'transparent'
                                  }"
                      placement-="bottom">
                  <img

                      [src]="r.icon"
                      [alt]="r.label"
                      [ngStyle]="{'opacity': r.status === 'no_available' ? '.5' : '1',
                                  'cursor': r.status === 'no_available' ? 'default' : 'pointer',
                                  'margin-bottom': i === 3 ? '-4px' : '0px',
                                  'margin-right': i === 3 ? '-4.5px' : '0px',
                                  'width': i === 3 ? '41.5px' : '39px',
                                  'height': i === 3 ? '41.5px' : '39px'
                                  }"
                      class="icon-board"
                      style=" object-fit: contain;">
                </div>
            </div>
        </div>
      </div>
      <div class="p-2 px-5 " style="width: 36.5%;border-left: 2px solid #e5e5e5;border-right: 2px solid #e5e5e5">
        <label style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;line-height: 1;margin-bottom: .55em;margin-left:1.5em;">Camas</label>
        <div class="d-flex align-items-center justify-content-center" style="gap: 1.7em;">
          <div>
             <img
              src="../../../../assets/icons/search-result/hotel/filtro/CAMA.svg"
              alt="bed"
              class="icon-board"
              style="width: 36.5px; height: 36.5px; object-fit: contain;margin-bottom: 2.5px">
          </div>
          <div class="d-flex align-items-center justify-content-between" style="gap: .35em;">
            <div *ngFor="let r of acomodationFiltersArr; let i = index"
                class="option-card"
                [class.selected]="selectedOptionIndexAcomodationFilter[i]"
                [ngStyle]="{'cursor': r.status === 'no_available' ? 'default' : 'pointer'}"
                (click)="filterTypeAcomodation(i, r.key)"
                >
                <div
                      class="d-flex justify-content-center align-items-center"
                      [ngStyle]="{'border': r.status !== 'no_available' ?
                                            '1.5px solid ' + clientSetting?.clients_setting_global?.color_main_1 :
                                            '1.5px solid #e0e0e0',
                                  'background-color': r.status !== 'no_available' &&
                                            selectedOptionIndexAcomodationFilter[i] ?
                                            clientSetting?.clients_setting_global?.color_main_1 + '30' :
                                            '#f2f2f2',
                                  'border-radius': i === 0 ? '50rem' : '50%',
                                  'width': i === 0 ? '42px' : '24px',
                                  'height': i === 0 ? '24px' : '24px'
                                          }"
                    [tooltip]="r.name"
                    placement="bottom">
                  <p class="mb-0 rubik-regular-12pt"
                     [ngStyle]="{'color': r.status !== 'no_available' ? clientSetting?.clients_setting_global?.color_main_1 : '#e0e0e0'}">{{r.key}}</p>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py-2 d-flex flex-column justify-content-between" style="width: 24.5%; padding-left: 3.8em">
          <label style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;line-height: 1;margin-bottom: .55em" >Políticas de cancelación</label>
          <div class="d-flex align-items-center " style="gap: 10px">
            <div *ngFor="let r of cancellationFiltersArr; let i = index"
                class="option-card"
                [class.selected]="selectedOptionIndexCancellationFilter[i]"
                (click)="filterTypeCancellation(i, r.key)"
                >
                <div
                      class="d-flex justify-content-center align-items-center"
                      style="padding:.25em;border-radius: 4px"
                      [tooltip]="r.name"
                      placement-="bottom">
                  <img [src]="r.icon"
                        [alt]="r.name"
                        [ngStyle]="{
                          'opacity': r.status === 'no_available' ? '0.5' : '1',
                          'cursor': r.status === 'no_available' ? 'default' : 'pointer',
                          'filter': r.key === 'R' && selectedOptionIndexCancellationFilter[i] ?
                                    'brightness(0) saturate(100%) invert(85%) sepia(19%) saturate(758%) hue-rotate(78deg) brightness(92%) contrast(88%)' :
                                    r.key === 'NR' && selectedOptionIndexCancellationFilter[i] ?
                                    'brightness(0) saturate(100%) invert(39%) sepia(86%) saturate(2196%) hue-rotate(328deg) brightness(97%) contrast(94%)' :
                                    'none'
                        }"
                        class="icon-board"
                        style="width: 38px; height: 38px; object-fit: contain;">
                </div>
            </div>
        </div>
      </div>


    </div>

    <div *ngIf="selectedRoomsFilterVisible" style="border-top: 2px solid #939292;margin-top: 15px;padding-top: 25px;margin-bottom: 25px;">
      <p class="mb-0 rubik-semibold-13pt ml-3 pl-4" style="font-size: 22px;padding-bottom: .6em;font-weight: 500;color: black">Habitaciones solicitadas</p>
  <!-- <p class="mb-0 rubik-semibold-13pt ml-3 pl-4" style="font-size: 22px;padding-bottom: .6em;font-weight: 500;color: black">Asignación de habitaciones (configuración de la búsqueda)</p> -->
      <div class="d-flex alig-items-center justify-content-center">



       <ng-container *ngFor="let item of roomsConfiguration; let i = index; let last = last;">

        <!-- <ng-container *ngIf="item"> -->
          <div
              class="d-flex flex-column justify-content-center align-items-center"
              style="width: 100%; min-height: 90px;gap: .75em"
              [style.border-right]="last ? 'none' : '1px solid #ccc'"
              [style.border-left]="i === 0 ? 'none' : '1px solid #ccc'"
              [style.background-color]="item ? 'white' : 'transparent'"
              [style.cursor]="item ? 'pointer' : 'default'"
              [style.opacity]="item ? '1' : '0.3'"
              (click)="filterItemConfigurationRoom(i, item)">
        <!-- [style.background-color]="activeFilterRoomsConfiguration(i, item) ? clientSetting?.clients_setting_global?.color_main_1 + '20' : 'white'" -->
              <div class="d-flex align-items-center">
                <p class="mb-0" style="font-family: 'Poppins'; font-size: 14px; font-weight: 600; line-height: 1;"
                        [style.color]="activeFilterRoomsConfiguration(i) ? clientSetting?.clients_setting_global?.color_main_1 : '#000000'"

                >Hab</p>
                <span style=" border-radius: 50%; padding: 4px; margin-left: 4px; display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px;"
                  [style.background-color]="activeFilterRoomsConfiguration(i) ? clientSetting?.clients_setting_global?.color_main_1 : '#000000'"
                >
                  <p class="mb-0" style="font-family: 'Poppins'; font-size: 12px; font-weight: 500; line-height: 1;color: white"

                  >{{ i + 1 }}</p>
                </span>
              </div>

              <div class="d-flex align-items-center" style="gap: 8px;">

                  <!-- Adultos -->
                <div class="d-flex align-items-center" style="gap: 4px;">
                  <p class="mb-0" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500; line-height: 1;"
                    [style.color]="activeFilterRoomsConfiguration(i) ? clientSetting?.clients_setting_global?.color_main_1 : '#000000'">
                    {{ item?.adults || '0' }}
                  </p>
                  <img #iconsFiltersConfigurationRoomsAdults src="../../../../assets/icons/search-result/persona.svg" style="width: 24px" alt="">
                </div>

                <!-- Niños -->
                <div class="d-flex align-items-center" style="gap: 4px;">
                  <p class="mb-0" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500; line-height: 1;"
                    [style.color]="activeFilterRoomsConfiguration(i) ? clientSetting?.clients_setting_global?.color_main_1 : '#000000'">
                    {{ item?.children?.length || '0' }}
                  </p>
                  <img #iconsFiltersConfigurationRoomsChildren src="../../../../assets/icons/search-result/hotel/infante.svg" style="width: 22px" alt="">
                </div>


              </div>



          </div>
        <!-- </ng-container>

        <ng-container *ngIf="!item">
          <div class="d-flex flex-column justify-content-center align-items-center"
              style="width: 100%; min-height: 90px;gap: .75em"></div>
        </ng-container> -->

        </ng-container>
      </div>

    </div>
  </div>

  <ng-container *ngIf="quote">
    <div [ngClass]="{'d-block': tab==='rooms', 'd-none': tab!='rooms' }">
        <div *ngIf="nuevoObjetoAux.length>0" >
          <ng-template ngFor let-room let-i="index" let-last="last" [ngForOf]="nuevoObjetoAux">
            <usb-room
                      #roomComponents
                      [room]='nuevoObjetoAux[i]'
                      [roomsSearch]="roomData"
                      [hotel]="hotel"
                      [hotelAdditionalInfo]='hotel.additionalInfo'
                      [allRoom] = 'nuevoObjetoAux'
                      [images]="imgList"
                      [select]="select"
                      [index]="i"
                      [last]="last"
                      [payload]="payload"
                      [productQty]="productQty"
                      [hotelDescription]="hotel?.description"
                      [clientSetting]="clientSetting"
                      [reserveMultiHab]="hotel.additionalInfo.reserveMultiHab"
                      [departureDate]="departureDate"
                      [buttonColorActiveDark]="buttonColorActiveDark"
                      [buttonColorActive]="buttonColorActive"
                      [backgroundSelect]="backgroundSelect"
                      [currencies]="currencies"
                      [currencyAgency]="currencyAgency"
                      [selectedRoomsParent]="selectedRooms"
                      [paymentAgencyActive]="paymentAgencyActive"
                      [buttonTextActive]="buttonTextActive"
                      [arrivalDate]="arrivalDate"
                      [selectedRoomsFilterVisible]="selectedRoomsFilterVisible"
                      (calculateTotalPrice)="calculateTotalPrice($event)"
                      (calculateTotalPriceWithout)="calculateTotalPriceWithout($event)"
                      (selectionChange)="selectionChange($event)"
                      (indexRoom)="selectedIndexRoom($event)"
                      (refreshCalculatePrice)="onRefreshCalculatePrice($event)"
                      (roomRemoved)="onRoomRemoved($event)"
                      (roomAdded)="onRoomAdded($event)"
                      (pushRoomSearch)="pushRoomSearch($event)">
            </usb-room>
          </ng-template>
        </div>


    <div *ngIf="hotel?.additionalInfo?.roomsPackage">
      <ng-template ngFor let-room let-i="index" [ngForOf]="hotel?.additionalInfo?.roomsPackage">
        <usb-room [room]='room' [images]="imgList" [select]="select" [index]="i" [productQty]="productQty" [hotel]="hotel" [hotelAdditionalInfo]='hotel.additionalInfo'
          [reserveMultiHab]="hotel.additionalInfo.reserveMultiHab"
          [currencyAgency]="currencyAgency"
          (calculateTotalPrice)="calculateTotalPrice($event)"></usb-room>
      </ng-template>
    </div>
  </div>
 </ng-container>
  <div [ngClass]="{'d-block': tab==='info', 'd-none': tab!='info' }">

      <usb-information
                        [product]="hotel"
                        [clientSetting]="clientSetting"
                        [currencies]="currencies"
                        [currencyAgency]="currencyAgency"
                        [coordinatesArr]="coordinatesArr"
                        [productInfo]="
                                        [
                                        'Descripción',
                                        hotel?.additionalInfo?.TimeInformation ? 'Check in - check out' : '',
                                        hotel?.additionalInfo?.checkin_requirement.length > 0 ? 'Requisitos' : '',
                                        hotel?.additionalInfo?.howtoget ? 'Como llegar' : '',
                                        hotel?.additionalInfo?.atracttions && hotel?.additionalInfo?.atracttions.length > 0 ? 'Atracciones cercanas' : '',
                                        arrFacilitiesAndService && arrFacilitiesAndService.length > 0 ? 'Observaciones' : '',
                                        hotel.additionalInfo?.frequentquestions && hotel.additionalInfo?.frequentquestions.length > 0 ? 'Preguntas frecuentes' : ''
                                        ]"
                        [categoryId]="1"
                        (goPhotos)="goPhothosTab()"
                      >
      </usb-information>

  </div>


  <div *ngIf="tab === 'maps'"  style="margin-left:.8em;margin-right:.8em">
        <app-map-view [coordinatesArr]="coordinatesArr"
                      [clientSetting]="clientSetting"
                      [currencies]="currencies"
                      mapMode="general"
                      [currencyAgency]="currencyAgency">
        </app-map-view>

  </div>

  <div [ngClass]="{'d-block': tab==='photos', 'd-none': tab!='photos' }" style="margin-left:2.8em;margin-right:2em">
    <span *ngIf="tab === 'photos'">
        <usb-photos
        [images]="hotel.additionalInfo.images">
        </usb-photos>
    </span>
  </div>

  <div [ngClass]="{'d-block': tab==='comments', 'd-none': tab!='comments' }">

    <ng-container *ngIf="hotel?.productId">
    <span *ngIf="tab === 'comments'">
    <usb-comments
        [action]="action"
        [clientSetting]="clientSetting"
        [payload]="payload"
        [productId]="hotel.productId"
        (closeModal)="close()"
      >
      </usb-comments>
    </span>
    </ng-container>



  </div>


  </div>
    </div>


  <div *ngIf="!view_info && tab ==='rooms' && quote && totalQty > 0"
        class="d-flex align-items-start mx-auto justify-content-between"
        style="height: 120px;
            gap: 1em;
            position: sticky;
            bottom: 0;
            width: 100%;
            border: 2px solid #bfbfbf;
            padding: 2em 5.5em 2.5em 5.5em;
            background-color: white;
            z-index: 2;">
    <div style="width: 100%;">

      <ng-container *ngIf="getGroupedSelectedRooms(selectedRooms).length > 0">
       <ng-container *ngFor="let room of getGroupedSelectedRooms(selectedRooms); let i = index">
          <p class="room-selected-title">{{ room?.displayName }}</p>
        </ng-container>
      </ng-container>

    </div>
    <div class="d-flex align-items-center justify-content-end" style="width: 100%; gap: 1em;">
      <div class="d-flex flex-column align-items-end justify-content-center">
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 16px;font-weight: 400;line-height: 1; color: #666666; margin-right: 16px;">Total Tarifa Neta</p>
        <div class="d-flex">
          <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 27px;font-weight: 500;line-height: 1; color: black">

            {{ totalQty
                    | currencyConverterPure:
                      currencySelected:
                      currencyAgency.code:
                      currencies
                    | number: '1.2-2'}}
          </p>
              <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="clientSetting"
                                            [currencyProduct]="currencySelected"
                                            [valueProduct]="totalQty"
                                            >
              </usb-tooltip-convert-amount>

        </div>
        </div>
        <button
                type="button"
                class="btn btn-continue"
                [ngStyle]="{'background-color':  buttonColorActive}"
                (click)="continue()"
                [disabled]="disableButton">Continuar
        </button>
    </div>

  </div>


</div>


